import "core-js/modules/es.array.reverse.js";
var _class, _OpenStreetMapCatalogItem;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { computed, makeObservable } from "mobx";
import UrlTemplateImageryProvider from "terriajs-cesium/Source/Scene/UrlTemplateImageryProvider";
import URI from "urijs";
import isDefined from "../../../Core/isDefined";
import CatalogMemberMixin from "../../../ModelMixins/CatalogMemberMixin";
import MappableMixin from "../../../ModelMixins/MappableMixin";
import OpenStreetMapCatalogItemTraits from "../../../Traits/TraitsClasses/OpenStreetMapCatalogItemTraits";
import CreateModel from "../../Definition/CreateModel";
import proxyCatalogItemUrl from "../proxyCatalogItemUrl";
let OpenStreetMapCatalogItem = (_class = (_OpenStreetMapCatalogItem = class OpenStreetMapCatalogItem extends MappableMixin(CatalogMemberMixin(CreateModel(OpenStreetMapCatalogItemTraits))) {
  constructor() {
    super(...arguments);
    makeObservable(this);
  }
  get type() {
    return OpenStreetMapCatalogItem.type;
  }
  forceLoadMapItems() {
    return Promise.resolve();
  }
  get mapItems() {
    const imageryProvider = this.imageryProvider;
    if (!isDefined(imageryProvider)) {
      return [];
    }
    return [{
      show: this.show,
      alpha: this.opacity,
      imageryProvider,
      clippingRectangle: this.clipToRectangle ? this.cesiumRectangle : undefined
    }];
  }
  get imageryProvider() {
    var _this$maximumLevel;
    if (!isDefined(this.templateUrl)) {
      return;
    }
    return new UrlTemplateImageryProvider({
      url: cleanAndProxyUrl(this, this.templateUrl),
      subdomains: this.subdomains.slice(),
      credit: this.attribution,
      maximumLevel: (_this$maximumLevel = this.maximumLevel) !== null && _this$maximumLevel !== void 0 ? _this$maximumLevel : 25,
      minimumLevel: this.minimumLevel,
      tileHeight: this.tileHeight,
      tileWidth: this.tileWidth
    });
  }
  get templateUrl() {
    if (!isDefined(this.url)) {
      return;
    }
    const templateUrl = new URI(this.url);
    if (this.subdomains.length > 0 && this.url.indexOf("{s}") === -1) {
      templateUrl.hostname("{s}.".concat(templateUrl.hostname()));
    }
    const path = templateUrl.path();
    const sep = path[path.length - 1] === "/" ? "" : "/";
    templateUrl.path("".concat(path).concat(sep, "{z}/{x}/{y}.").concat(this.fileExtension));
    return decodeURI(templateUrl.toString());
  }
}, _defineProperty(_OpenStreetMapCatalogItem, "type", "open-street-map"), _OpenStreetMapCatalogItem), _applyDecoratedDescriptor(_class.prototype, "mapItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "mapItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "imageryProvider", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "imageryProvider"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "templateUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "templateUrl"), _class.prototype), _class);
export { OpenStreetMapCatalogItem as default };
function cleanAndProxyUrl(catalogItem, url) {
  return proxyCatalogItemUrl(catalogItem, cleanUrl(url));
}
function cleanUrl(url) {
  // Strip off the search portion of the URL
  const uri = new URI(url);
  uri.search("");
  return decodeURI(url.toString());
}